export enum ProjectType {
  Project = 'Project',
  SubProject = 'Sub-Project',
}
